import axiosInstance from "../axiosConfig";

// Service for handling credit note related API calls
const creditNoteService = {
  // Get all credit notes
  getAllCreditNotes: async () => {
    try {
      const response = await axiosInstance.get("/credit-notes");
      return response.data;
    } catch (error) {
      console.error("Error fetching credit notes:", error);
      throw error;
    }
  },

  // Get credit note by ID
  getCreditNoteById: async (id) => {
    try {
      const response = await axiosInstance.get(`/credit-notes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching credit note with id ${id}:`, error);
      throw error;
    }
  },

  // Create a new credit note
  createCreditNote: async (creditNoteData) => {
    try {
      const response = await axiosInstance.post(
        "/credit-notes",
        creditNoteData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating credit note:", error);
      throw error;
    }
  },

  // Update an existing credit note
  updateCreditNote: async (id, creditNoteData) => {
    try {
      const response = await axiosInstance.put(
        `/credit-notes/${id}`,
        creditNoteData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating credit note with id ${id}:`, error);
      throw error;
    }
  },

  // Delete a credit note
  deleteCreditNote: async (id) => {
    try {
      const response = await axiosInstance.delete(`/credit-notes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting credit note with id ${id}:`, error);
      throw error;
    }
  },

  // Void a credit note
  voidCreditNote: async (id) => {
    try {
      const response = await axiosInstance.post(`/credit-notes/${id}/reverse`);
      return response.data;
    } catch (error) {
      console.error(`Error voiding credit note with id ${id}:`, error);
      throw error;
    }
  },

  // Get credit notes by customer
  getCreditNotesByCustomer: async (customerId) => {
    try {
      const response = await axiosInstance.get("/credit-notes", {
        params: { customerId },
      });
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching credit notes for customer ${customerId}:`,
        error
      );
      throw error;
    }
  },

  // Get credit notes by invoice
  getCreditNotesByInvoice: async (invoiceId) => {
    try {
      const response = await axiosInstance.get("/credit-notes", {
        params: { invoiceId },
      });
      return response.data;
    } catch (error) {
      console.error(
        `Error fetching credit notes for invoice ${invoiceId}:`,
        error
      );
      throw error;
    }
  },

  // Apply a standalone credit note to an invoice of the same customer.
  applyCreditNote: async (creditNoteId, invoiceId, amount) => {
    try {
      const response = await axiosInstance.post(`/credit-notes/${creditNoteId}/allocate`, { invoiceId, amount });
      return response.data;
    } catch (error) {
      console.error(`Error applying credit note ${creditNoteId}:`, error);
      throw error;
    }
  },
};

export default creditNoteService;
